module.exports = __webpack_public_path__ + "static/img/bg-slight-production-onama.6b7a2d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/bg-slight-production-onama.jpg
// module id = vXVE
// module chunks = 1